import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'app/shared/services/api.service';
@Component({
  selector: 'app-create-batch',
  templateUrl: './create-batch.component.html',
  styleUrls: ['./create-batch.component.scss']
})
export class CreateBatchComponent implements OnInit {
   @ViewChild('vform') validationForm: FormGroup;
  batchForm:FormGroup;
  selectValue='';
  selectedValue=null;
  course_id:'';
  courselist:[]
  fileData:File;
  isOffline:boolean=false
  batchFormSubmitted:boolean=false;
  learningMode=null
  learningList=[];
 learningId= "631ad8abce5c666542591bd9"
 usersList =[]
 selected_user =null
  constructor(private formBuilder: FormBuilder,
    public toastr: ToastrService,
    public apiService:ApiService,
    private route:Router) { }
days:[]
  ngOnInit(): void {this.getLearningTagBycategory(),
   this.getCourseList()
    this.batchForm=this.formBuilder.group({
    name: ['', Validators.required],
    course_id: ['', Validators.required],
    start_date: ['', Validators.required],
    start_time: ['', Validators.required],
    end_time: ['', Validators.required],
    description: ['', Validators.required],
    days: ['', Validators.required],
    specailnotes: ['', Validators.required],
    instructor: ['', Validators.required],
     learning_mode: ['', Validators.required],
    joining_link: ['', Validators.required],
    max_student: ['', Validators.required],
    notes: ['', Validators.required],
    admin_notes: ['', Validators.required],

  })
  this.getUsers()
  }
  getUsers() {
    this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
      this.usersList = res.items
    })
  }
  getSelectUserId(event: any) {
    this.selected_user
  }
  getCourseList(){
    this.apiService.getCourseList(1,100).subscribe((res:any)=>{
       this.courselist= res.data.items
    })
  }
  getCourseById(event){
   this.selectedValue

  }
  getLearningTagBycategory(){
    this.apiService.getTagByTagCatgoryId(this.learningId).subscribe((res:any)=>{
      this.learningList=res.data
    })
   }
   getLearningId(event:any){
    this.learningMode
   }
  // change(event){
  //   this.selectValue=event.target.value
  //   if(this.selectValue=='online'){
  //     this.isOffline=true
  //     console.log('batch type',this.selectValue)
  //   }
  //   else if(this.selectValue=='offline'){
  //     this.isOffline=false
  //     console.log('batch type',this.selectValue)
  //   }
  //  }
  get rf() {
    return this.batchForm.controls;
  }
  submitCourse(){
    let body={
      name:this.batchForm.value.name,
      start_date:this.batchForm.value.start_date,
      course_id:this.selectedValue,
      end_time:this.batchForm.value.end_time,
      start_time:this.batchForm.value.start_time,
      description:this.batchForm.value.description,
      days:this.batchForm.value.days,
      specailnotes:this.batchForm.value.specailnotes,
      instructor : this.selected_user,
      learning_mode:this.learningMode,
      joining_link:this.batchForm.value.joining_link,
      max_student:this.batchForm.value.max_student,
      admin_notes:this.batchForm.value.admin_notes,
      notes:this.batchForm.value.notes,
    }
     this.apiService.createBatch(body).subscribe((res:any)=>{
      if(res.statusCode === 200){
       console.log('create-Batch',res)
        this.toastr.success(res.message)
       this.route.navigate(['/batches/batch-list']) 
      } 
      else{this.toastr.error(res.error)}  
     })
     this.batchFormSubmitted = true;
     if (this.batchForm.invalid) {
       return;
     }

}
back(){
this.route.navigate(['/batches/batch-list'])    
} 
}